export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20illustration%20of%20a%20cozy%20reading%20nook%20with%20open%20manga%20books%20scattered%20on%20a%20wooden%20table%2C%20soft%20golden%20afternoon%20light%20streaming%20through%20sheer%20curtains%2C%20warm%20cream%20and%20caramel%20color%20palette%2C%20Japanese%20manga%20aesthetic%20blended%20with%20modern%20editorial%20illustration%20style%2C%20dreamy%20atmospheric%20composition%20with%20gentle%20shadows%2C%20artistic%20painterly%20texture%2C%20serene%20and%20inviting%20mood&width=1800&height=1000&seq=hero-manga-main&orientation=landscape"
          alt="女神漫画网追更体验"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-0">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium tracking-wider bg-primary-500/20 text-primary-200 border border-primary-400/30 mb-5">
              连载追更
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-4">
              女神漫画网
              <br className="hidden sm:block" />
              <span className="text-primary-300">你的专属追更管家</span>
            </h1>

            <p className="text-lg md:text-xl text-white/80 font-heading italic mb-6">
              不再错过任何一话，第一时间掌握连载动态
            </p>

            <p className="text-sm md:text-base text-white/70 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              女神漫画网追更频道实时追踪热门韩漫、日漫与国漫连载更新，覆盖都市言情、奇幻冒险、悬疑推理等多元题材。无论你追的是周更热门还是冷门佳作，这里都能一键订阅、自动提醒，下拉式追更体验让阅读更沉浸、更顺畅，免费全集持续更新中。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-white font-heading">3000+</div>
                <div className="text-xs text-white/60 mt-1">热门漫画覆盖</div>
              </div>
              <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-white font-heading">每日更新</div>
                <div className="text-xs text-white/60 mt-1">实时提醒推送</div>
              </div>
              <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-white font-heading">韩日国全覆盖</div>
                <div className="text-xs text-white/60 mt-1">多元题材任选</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 hover:bg-primary-600 text-white font-bold text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                开始追更
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#about"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border-2 border-white/30 hover:border-white/60 text-white font-medium text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                了解详情
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-black/30 aspect-[4/5] max-w-[400px] mx-auto lg:mx-0 lg:ml-auto">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20portrait%20of%20a%20young%20woman%20with%20flowing%20dark%20hair%20reading%20a%20manga%20on%20a%20digital%20tablet%2C%20warm%20golden%20ambient%20lighting%2C%20surrounded%20by%20floating%20manga%20pages%20and%20soft%20cherry%20blossom%20petals%2C%20Japanese%20illustration%20style%20with%20modern%20clean%20aesthetic%2C%20warm%20cream%20and%20rose%20gold%20tones%2C%20editorial%20quality%2C%20dreamy%20atmosphere%2C%20serene%20expression%2C%20artistic%20composition&width=800&height=1000&seq=hero-manga-visual&orientation=portrait"
                alt="女神漫画网追更视觉"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}